// extracted by mini-css-extract-plugin
export default {"container":"dM-z","error":"eM-z","disabled":"fM-z","submit":"gM-z","option":"hM-z","success":"iM-z","failure":"jM-z"};